const reasons = [
  { icon: 'ri-user-star-line', text: 'Experienced HVAC technicians with real-world expertise' },
  { icon: 'ri-time-line', text: 'Reliable, on-time service — available 24/7' },
  { icon: 'ri-brush-line', text: 'Clean, professional work on every job' },
  { icon: 'ri-line-chart-line', text: 'Long-term system performance focus' },
  { icon: 'ri-building-2-line', text: 'Residential and commercial expertise' },
  { icon: 'ri-bank-card-line', text: '100% financing available — get serviced immediately' },
];

export default function WhyChoose() {
  return (
    <section id="why-choose" className="bg-[#0f1923] py-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        {/* Full-width image banner */}
        <div className="relative w-full h-64 md:h-80 rounded-2xl overflow-hidden mb-16">
          <img
            src="https://public.readdy.ai/ai/img_res/d49f0dad990863f55c9723bf542cfd9c.jpg"
            alt="Air-Tek NC professional HVAC team"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0a1628]/85 via-[#0a1628]/50 to-transparent" />
          <div className="absolute inset-0 flex items-center px-10 md:px-16">
            <div>
              <span className="text-[#00d4ff] text-xs font-bold tracking-widest uppercase">Why Air-Tek NC</span>
              <h2
                className="text-3xl md:text-5xl font-bold text-white mt-2 leading-tight"
                style={{ fontFamily: 'Outfit, sans-serif' }}
              >
                Built on Precision,
                <br />
                Reliability &amp; <span className="text-[#00d4ff]">Experience</span>
              </h2>
            </div>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row gap-16 items-start">
          {/* Left */}
          <div className="lg:w-[42%]">
            <p className="text-[#9ca3af] text-base leading-relaxed mb-8">
              Over a decade of combined experience with competitive pricing allows our customers to rest easy. We don&apos;t just fix HVAC systems — we build lasting comfort solutions for Southern NC homes and businesses.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="tel:9193489399"
                className="flex items-center justify-center gap-2 bg-[#00d4ff] hover:bg-[#00b8d9] text-[#0a1628] font-bold text-sm px-6 py-3 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-fill" />
                </div>
                (919) 348-9399
              </a>
              <a
                href="mailto:airteknc@gmail.com"
                className="flex items-center justify-center gap-2 border border-white/20 hover:border-[#00d4ff]/50 text-white text-sm px-6 py-3 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-[#00d4ff]" />
                </div>
                airteknc@gmail.com
              </a>
            </div>
          </div>

          {/* Right */}
          <div className="lg:w-[58%]">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {reasons.map((r) => (
                <div
                  key={r.text}
                  className="flex items-start gap-4 bg-[#1a2535] rounded-xl p-5 border border-white/5 hover:border-[#00d4ff]/20 transition-all duration-200 group cursor-default"
                >
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-[#00d4ff]/10 border border-[#00d4ff]/20 shrink-0 group-hover:bg-[#00d4ff]/20 transition-colors duration-200">
                    <i className={`${r.icon} text-[#00d4ff] text-lg`} />
                  </div>
                  <p className="text-white text-sm font-medium leading-relaxed pt-1">{r.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
